import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Category,CategoryService } from './category.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { AlertService} from './../services/alert.service';
import {Contact,ContactService } from './../contact/contact.service';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
declare var jQuery: any;

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string; 
  product_name: string; 
  image: string; 
  image1: string; 
  image2: string;
  image3: string;
  image4: string;
  image5: string; 
  price: string; 
  product_description: string; 
  slug: string; 
  short_description:string;
  catslug:string;
       
}
let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.product)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/product/product.component.html'}
}
else
{
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)
/*
@Component({
	//template: require('./product.component.html')
	templateUrl: './pg/product/product.component.html',	
	
})*/
export class ProductComponent implements OnInit {
	
	public params;
	public apiData;
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    public singleproduct:Array<any>;
    InqueryForm: FormGroup;
    public currentslug;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private alertService: AlertService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private _location:Location,
	    public fb: FormBuilder,  
	    private _contactService: ContactService,
	    private _pageService: CategoryService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  product_name:'', 
				  image:'', 
				  image1:'',
				  image2:'',
				  image3:'', 
				  image4:'', 
				  image5:'',  
				  price:'', 
				  product_description:'', 
				  short_description:'',
				  slug:'',
				  catslug:''
                 
				  	}
		   this.InqueryForm = fb.group({
      'email': [
        '', // default value
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      'name': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
      
       'phone': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ], 
      'subject': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ],
   
      'message': [
        '',
        Validators.compose([Validators.required, Validators.minLength(5)])
      ]


    });			
				  	
				  	    
	    }
	    
     
	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	       window.scrollTo(0, 0);
	   this.slimLoadingBarService.start();     
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			this.currentslug=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			   
			   this._pageService.getProduct(slug).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                 // this.pagedata.description=data.data.menu.description;                 
                  if(data.product.meta_title)
                  this._title.setTitle(data.product.meta_title);
                  else
                  this._title.setTitle(data.product.product_name);                  
                  this.pagedata.product_name=data.product.product_name;
                  this.pagedata.product_description=data.product.product_description;
                  this.pagedata.short_description=data.product.short_description;
                  this.pagedata.price=data.product.price;
                  this.pagedata.image=data.product.image;
                  this.pagedata.image1=data.product.image1;
                  this.pagedata.image2=data.product.image2;
                  this.pagedata.image3=data.product.image3;
                  this.pagedata.image4=data.product.image4;
                  this.pagedata.image5=data.product.image5;
                  this.pagedata.catslug=data.menu.slug;
                  this.slimLoadingBarService.complete();
                   let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);
                  ///alert(data.data.product.image1);
                  //$window.document.title ='someTitleYouCreated' ;              
           
        },
        err => console.error(err)
        
    );
			  
			   
			   			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    
     InqueryValidate(): boolean {

  if (this.InqueryForm.valid) {
    return true;
  }
  let errorMsg = '';

  let field_name = this.InqueryForm.controls['name'];
  if (!field_name.valid) {
    if (field_name.errors['required']) {
      errorMsg = 'Provide a Name please.<br />';
    }
  }

  let fieldemail = this.InqueryForm.controls['email'];
  if (!fieldemail.valid) {
    if (fieldemail.errors['required']) {
      errorMsg = errorMsg+'Provide a Email please.<br />';
    }
  }
 
  let fieldmesage = this.InqueryForm.controls['message'];
  if (!fieldmesage.valid) {
    if (fieldmesage.errors['required']) {
      errorMsg = errorMsg+'Provide a Message please.<br />';
    }
  }
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
     
     doInquery(event) {
       
       
     if (this.InqueryValidate()) {
    
            let name = this.InqueryForm.controls['name'].value;
			let phone = this.InqueryForm.controls['phone'].value;
			let email = this.InqueryForm.controls['email'].value;
			//let subject ='Product Inquery';
			let slug =this.currentslug;
			let message = this.InqueryForm.controls['message'].value;
            this.params = {
                 
                  name: name,
                  email: email,
                  phone: phone,
                  slug:slug,
                  message:message,
                };
               this._pageService.doContactUs(this.params).subscribe(
        data => {
            this.apiData = data;
             //loading.dismiss();
             
             if(data.status=='success')
             {
	              this.alertService.success(data.message);
	              this.reset();
	              
             }
             else
             {
	             this.alertService.error(data.message);
             }
           
            
        },
        err => console.error(err),
        () => console.log('services completed')
    );
               console.log(this.InqueryForm.value);
               
               
               
              
    };
  }
    backClicked() {
    
        this._location.back();
    }
    
     reset() {
     this.InqueryForm.reset();
       }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/product/product.component.ts